import React, { FC, useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

type BarcodeItemProps = {
  sku: string,
}

export const BarcodeItem: FC<BarcodeItemProps> = ({ sku }) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (barcodeRef.current && sku) {
      try {
        JsBarcode(barcodeRef.current, sku, {
          format: "CODE128",
          width: 2,
          height: 80,
          displayValue: true,
          fontSize: 14,
          margin: 5,
        });
      } catch (error) {
        console.error(`Error generating barcode for ${sku}:`, error);
      }
    }
  }, [sku]);

  return (
    <div className="barcode-container flex justify-center items-center" style={{ margin: '20px 0', border: '1px solid #ccc', padding: '10px', background: "#fff" }}>
      <svg ref={barcodeRef} width="200" height="100"></svg>
    </div>
  );
};
